const selector = {
    btnCheckSerialNumber: '.js_action_check_tag',
    inputSerialNumber: '#serial_number_input',
    configuration: '#uputstvo',
    additionalBtns: '.additional-btns',
    lang: 'input[name="lang"]',
};

export { selector };